import React from "react"

type Props = {
  className?: string
}

const SearchIcon = ({ className }: Props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.2509 17.5023V22.0042L12 20.8787L9.74902 22.0042V17.5023"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.21857 14.8382L8.75079 15.5385L8.86584 16.4038C8.92979 16.8837 9.30733 17.2613 9.78722 17.3252L10.6546 17.4413L11.3489 17.9725C11.7332 18.2646 12.2651 18.2646 12.6494 17.9725L13.3497 17.4413L14.2161 17.3252C14.6962 17.2614 15.0741 16.8839 15.1385 16.4038L15.2545 15.5365C15.2545 15.5365 15.5226 15.1853 15.7857 14.8422C16.0779 14.4579 16.0779 13.9259 15.7857 13.5416L15.2545 12.8414L15.1385 11.976C15.075 11.496 14.6979 11.1181 14.2181 11.0536L13.3497 10.9386L12.6494 10.4083C12.2655 10.1151 11.7328 10.1151 11.3489 10.4083L10.6486 10.9386L9.78222 11.0536C9.30217 11.1172 8.92446 11.4949 8.86084 11.975L8.74479 12.8424L8.21357 13.5366C7.92306 13.9225 7.9251 14.4546 8.21857 14.8382Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0019 19.0029H19.0028C20.1078 19.0029 21.0036 18.1071 21.0036 17.0021V5.59033C21.0036 4.4853 20.1078 3.58949 19.0028 3.58949H4.99693C3.8919 3.58949 2.99609 4.4853 2.99609 5.59033V17.0021C2.99609 18.1071 3.8919 19.0029 4.99693 19.0029H6.99776"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.49805 6.99792H16.5018"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SearchIcon
